// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import userModule css modules
import userModuleStyles from '../userModuleModuleStyles.css';

function UserModuleListItem({ userModule }) {
  return (
    <li>
      <Link to={`/user-modules/${userModule._id}`}> {userModule.name}</Link>
    </li>
  )
}

UserModuleListItem.propTypes = {
  userModule: PropTypes.object.isRequired
}

export default UserModuleListItem;



// WEBPACK FOOTER //
// modules/userModule/components/UserModuleListItem.js.jsx